module.exports = __webpack_public_path__ + "img/download-2-3INT.e3461ab5.png";